// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__ulNU\\+ {
  position: relative; }

.styles_wrapper__hNp-L {
  padding: unset; }
  .styles_wrapper__hNp-L > div {
    padding: 0rem;
    padding-bottom: 0rem; }
    .styles_wrapper__hNp-L > div > div {
      border: unset;
      padding: unset;
      box-shadow: unset; }

.styles_footer__hSjYP {
  position: relative;
  bottom: 0rem;
  left: 0rem;
  width: -webkit-fill-available;
  display: flex;
  justify-content: flex-end;
  margin-top: 0.9rem;
  box-shadow: unset; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/components/form/Form/SchemaFormField/SchemaFormArrayField/styles.module.scss"],"names":[],"mappings":"AACA;EACI,kBAAkB,EAAA;;AAEtB;EACI,cAAc,EAAA;EADlB;IAGQ,aAAa;IACb,oBAAoB,EAAA;IAJ5B;MAMY,aAAa;MACb,cAAc;MACd,iBAAiB,EAAA;;AAK7B;EACI,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB,EAAA","sourcesContent":["\n.container {\n    position: relative;\n}\n.wrapper {\n    padding: unset;\n    & > div {\n        padding: 0rem;\n        padding-bottom: 0rem;\n        & > div {\n            border: unset;\n            padding: unset;\n            box-shadow: unset;\n        }\n    }\n}\n\n.footer {\n    position: relative;\n    bottom: 0rem;\n    left: 0rem;\n    width: -webkit-fill-available;\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 0.9rem;\n    box-shadow: unset;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__ulNU+`,
	"wrapper": `styles_wrapper__hNp-L`,
	"footer": `styles_footer__hSjYP`
};
export default ___CSS_LOADER_EXPORT___;
